import {
  RETAILERS_SET_ORDER,
  RETAILERS_SET_ORDER_FIELD,
  PRODUCTS_CHECK_PERMISSION,
  PRODUCTS_UNCHECK_PERMISSION,
  BRAND_ORDERS_RETAILER_FILTER,
  CHANGE_DATE_RANGE,
} from '../constants/pageFiltersTypes';

/*
 * We will soon deprecate moment in favor of date-fns.
 * Moment is still required here due to the DateRange component.
 */
import moment from 'moment';

let startDate = localStorage.getItem('startDate')
  ? moment(new Date(localStorage.getItem('startDate')))
  : moment().startOf('day');
if (!startDate.isValid()) {
  startDate = moment().startOf('day');
}

let endDate = localStorage.getItem('endDate')
  ? moment(new Date(localStorage.getItem('endDate')))
  : moment().endOf('day');
if (!endDate.isValid() || endDate.isBefore(startDate)) {
  endDate = moment(startDate).endOf('day');
}

const initialState = {
  products: {
    checked: {},
    checked_permission: [],
  },
  retailers: {
    field: 'created_at',
    order: 'asc',
  },
  orders: {
    retailer: 'all',
  },
  dateRange: {
    startDate,
    endDate,
  },
};

const pageFilters = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCTS_CHECK_PERMISSION:
      return {
        ...state,
        products: {
          ...state.products,
          checked_permission: [...state.products.checked_permission, action.payload],
        },
      };
    case PRODUCTS_UNCHECK_PERMISSION:
      return {
        ...state,
        products: {
          ...state.products,
          checked_permission: state.products.checked_permission.filter((item) => item !== action.payload),
        },
      };
    case CHANGE_DATE_RANGE:
      return {
        ...state,
        dateRange: {
          ...action.payload,
        },
      };
    case RETAILERS_SET_ORDER:
      return {
        ...state,
        retailers: {
          ...state.retailers,
          order: action.payload,
        },
      };
    case RETAILERS_SET_ORDER_FIELD:
      return {
        ...state,
        retailers: {
          ...state.retailers,
          field: action.payload,
        },
      };
    case BRAND_ORDERS_RETAILER_FILTER: {
      return {
        ...state,
        orders: {
          ...state.orders,
          retailer: action.payload,
        },
      };
    }
    default:
      break;
  }
  return state;
};

export default pageFilters;
